import React, { useEffect } from 'react'
import classes from "./Home.module.css";
import logo from '../../assets/images/logo.png'
import { Link } from 'react-router-dom'

const HomeComponent = ({
	resetCatelogData,
	resetSelectedCatalogDoor,
	selectedCatalogImageDimensions
}) => {
	useEffect(() => {
		resetCatelogData && resetCatelogData()
		resetSelectedCatalogDoor && resetSelectedCatalogDoor()
	}, [resetCatelogData])
	return (
		<>
			<div className={classes.homeContainer}>
				<img src={logo} className={classes.logoImage} alt="logo" />
				<div className={classes.contentWrapper}>
					<h3 className={classes.title}>Welcome to modif<span>AI</span></h3>
					<h2 className={classes.subTitle}>Try out new doors on your home</h2>
				</div>
				<div className={classes.buttonWrapper}>
					<Link to="/modifai/garage">
						<button className={[classes.button, classes.primaryButton].join(' ')}>GARAGE DOORS</button>
					</Link>
					<Link to="/modifai/frontdoor">
						<button className={[classes.button, classes.secondaryButton].join(' ')}>ENTRY DOORS</button>
					</Link>
				</div>
			</div>
		</>
	)
}

export default HomeComponent;